module.exports = __webpack_public_path__ + "img/carte.b6db817c.jpg";